import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { FormControl, InputLabel, MenuItem, Select, CircularProgress } from "@mui/material";
import { useUnit } from "effector-react";
import {
  getFleetsEffect,
  getFleetsByClientEffect,
} from "../../stores/FleetsStore/FleetsStore.effects";
import {
  getCustomersEffect,
  getWashingTypesEffect,
} from "../../stores/CustomersStore/CustomersStore.effects";
import { FleetsStore } from "../../stores/FleetsStore/FleetsStore";
import { CustomersStore } from "../../stores/CustomersStore/CustomersStore";
import AddFleet from "./components/AddFleet/AddFleet";
import VehicleRow from "./components/VehicleRow/VehicleRow";
import { NotFound } from "./FleetsStyles";
import { PageContainer, PageHeader, PageTitle } from "../../components/PageLayout";

const Fleets: React.FC = () => {
  const { fleets } = useUnit(FleetsStore);
  const { customers } = useUnit(CustomersStore);
  const loadingAll = useUnit(getFleetsEffect.pending);
  const loadingByClient = useUnit(getFleetsByClientEffect.pending);
  const loading = loadingAll || loadingByClient;
  const [selectedClientId, setSelectedClientId] = useState<string>("");

  useEffect(() => {
    getFleetsEffect();
    getCustomersEffect();
    getWashingTypesEffect();
  }, []);

  const handleClientFilter = (clientId: string) => {
    setSelectedClientId(clientId);
    if (clientId) {
      getFleetsByClientEffect(clientId);
    } else {
      getFleetsEffect();
    }
  };

  const renderFleets = () => {
    if (loading && !fleets?.length)
      return <tr><NotFound colSpan={5}><CircularProgress size={28} /></NotFound></tr>;

    if (!fleets?.length) return <tr><NotFound colSpan={5}>Sem frotas para exibir</NotFound></tr>;

    return fleets.map((fleet) => (
      <VehicleRow key={fleet.id} fleet={fleet} />
    ));
  };

  return (
    <PageContainer style={{ height: "100%", boxSizing: "border-box", overflow: "hidden" }}>
      <PageHeader>
        <PageTitle>Frotas</PageTitle>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <FormControl size="small" sx={{ minWidth: 220, backgroundColor: "#fff" }}>
            <InputLabel>Filtrar por cliente</InputLabel>
            <Select
              value={selectedClientId}
              label="Filtrar por cliente"
              onChange={(e) => handleClientFilter(e.target.value)}
            >
              <MenuItem value="">Todos</MenuItem>
              {customers.map((c) => (
                <MenuItem key={c.id} value={c.id}>
                  {c.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <AddFleet />
        </div>
      </PageHeader>
      <TableContainer
        sx={{ flex: 1, minHeight: 0, overflow: "auto" }}
        component={Paper}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="fleets table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ whiteSpace: "nowrap" }}>Cliente</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>Descrição</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>Tipo de Lavação</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>Uso x Limite</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>Utilizado</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }} align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderFleets()}</TableBody>
        </Table>
      </TableContainer>
    </PageContainer>
  );
};

export default Fleets;
